import React from 'react';
import { useLocation } from 'react-router';
import { Box, List, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import NavCollapse from './NavCollapse';
import NavGroup from './NavGroup/NavGroup';
import getMenuItems from './MenuItems';
import { userSelector } from 'src/store/apps/slices/UserSlice';
import { isRootAdminUser } from 'src/lib/utils';

const SidebarItems = () => {
  const { pathname } = useLocation();
  const pathDirect = pathname;
  const customizer = useSelector((state) => state.customizer);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const hideMenu = lgUp ? customizer.isCollapse && !customizer.isSidebarHover : '';
  const { user, loading } = useSelector(userSelector);
  const isRootAdmin = isRootAdminUser(user);
  if (loading || !user) return null; 
  const menuItems = getMenuItems(user?.permissions, isRootAdmin, user);

  return (
    <Box sx={{ px: 3 }}>
      <List sx={{ pt: 0 }} className="sidebarNav">
        {menuItems.map((item) => {
          if (item.navlabel) {
            return (
              <React.Fragment key={item.subheader}>
                <NavGroup
                  key={item.subheader}
                  item={item}
                  hideMenu={hideMenu}
                  pathDirect={pathDirect || ''}
                />
                {!hideMenu &&
                  item.items?.map((childItem) => {
                    if (childItem.children) {
                      return (
                        <NavCollapse
                          menu={childItem}
                          pathDirect={pathDirect}
                          hideMenu={hideMenu}
                          level={1}
                          key={childItem.id}
                        />
                      );
                    } else {
                      // return (
                      //   <NavItem
                      //     item={childItem}
                      //     key={childItem.id}
                      //     pathDirect={pathDirect}
                      //     hideMenu={hideMenu}
                      //   />
                      // );
                    }
                  })}
              </React.Fragment>
            );
          }
          return null;
        })}
      </List>
    </Box>
  );
};
export default SidebarItems;
